<template>
  <q-page class="container" padding>
    <PageHeader
      title="Relatório de Ferramentas"
      :backRoute="{ name: 'home' }"
      backBehavior="route"
    />
    <q-form>
      <div class="row col-12 q-col-gutter-sm q-mb-xl q-mt-sm">
        <div class="col-md col-xs-6 text-brand-5 text-weight-bold">
          Unidade

          <lista-unidades-select
            v-model="recebeUnidade.unidade"
          ></lista-unidades-select>
        </div>

        <div class="col-md col-xs-5 text-brand-5 text-weight-bold">
          Nome do Colaborador
          <q-input
            input-debounce="500"
            dense
            outlined
            v-model="filtros.funcionario"
            type="text"
          />
        </div>
        <div class="col-md col-xs-5 text-brand-5 text-weight-bold">
          Status
          <q-select
            input-debounce="500"
            dense
            outlined
            v-model="filtros.status"
            :options="status"
          />
        </div>
        <div class="col-md col-xs-6 text-brand-5 text-weight-bold">
          Código
          <q-input input-debounce="500" dense outlined v-model="filtros.codigo">
          </q-input>
        </div>
        <div class="col-md col-xs-5 text-brand-5 text-weight-bold">
          Descrição
          <q-input
            input-debounce="500"
            dense
            outlined
            v-model="filtros.descricao"
          >
          </q-input>
        </div>
        <div class="col-md col-xs-6 text-brand-5 text-weight-bold">
          Patrimônio
          <q-input
            input-debounce="500"
            dense
            outlined
            v-model="filtros.patrimonio"
          >
          </q-input>
        </div>
        <div class="col-md col-xs-6 text-brand-5 text-weight-bold">
          <SelectComponentGrupos
            @emitirGrupo="receberDadosGrupo"
            :subGrupoCategoriaUuid="subGrupo.uuid"
          />
        </div>
        <div class="col-md col-xs-5 text-brand-5 text-weight-bold">
          <SelectComponentSubGrupos
            @emitirSubGrupo="receberDadosSubGrupo"
            :categoriaUuid="grupo?.uuid"
          />
        </div>
      </div>
    </q-form>
    <p class="text-h6 text-brand-5 text-weight-medium">Ferramentas</p>
    <div class="q-mt-md">
      <q-table
        table-header-class="bg-accent text-weight-bold"
        id="customers"
        class="q-mt-sm table_header tabela-tamanho-fixo"
        title=""
        :rows="ferramentas"
        dense
        :columns="columns"
        hide-pagination
        :rows-per-page-options="[0]"
        :no-data-label="semDados ? 'Ferramenta(s) não encontradas' : ''"
        :hide-bottom="hideBottom"
        :loading="loading"
        flat
      >
        <template v-slot:body="props">
          <q-tr :props="props">
            <q-td class="text-left" key="unidade" :props="props">{{
              props.row.nome_vendor
            }}</q-td>
            <q-td class="text-left" key="codigo" :props="props">{{
              props.row.ferramenta
            }}</q-td>
            <q-td class="text-left" key="descricao" :props="props">{{
              props.row.descricao
            }}</q-td>
            <q-td class="text-left" key="preco" :props="props"
              ><span class="row nao-quebrar-linha">
                {{ props.row.preco ? `R$${props.row.preco}` : "" }}
              </span></q-td
            >
            <q-td class="text-left" key="patrimonio" :props="props">{{
              props.row.numero_patrimonio
            }}</q-td>

            <q-td class="text-left" key="permanencia" :props="props">
              <div>
                {{
                  props.row.tempo_permanencia
                    ? props.row.tempo_permanencia + "m"
                    : "N/D"
                }}
              </div>
            </q-td>

            <q-td class="text-left" key="status" :props="props">
              <div
                :style="
                  props.row.status == 'disponivel'
                    ? 'width: fit-content; background: #e8ffec; padding: 2px 5px;'
                    : props.row.status == 'manutencao_garantia'
                    ? 'width: fit-content; background: #e6e6e6'
                    : props.row.status == 'uso'
                    ? 'width: fit-content; background: #fefed1; padding: 2px 5px;'
                    : props.row.status == 'manutencao'
                    ? 'width: fit-content; background: #ffe9e9; padding: 2px 5px;'
                    : props.row.status == 'em_transito'
                    ? 'width: fit-content; background:  #f8f8f8'
                    : props.row.status == 'removida' ||
                      props.row.status == 'calibracao'
                    ? 'width: fit-content; background:  #9BA4B5; padding: 2px 5px;'
                    : props.row.status == 'retorno_em_garantia'
                    ? 'width: fit-content; background:  #9BA4B5'
                    : props.row.status == 'desmobilizada'
                    ? 'width: fit-content; background:  #EDBC5A; padding: 2px 5px;'
                    : props.row.status == 'reativacao'
                    ? 'width: fit-content; background:  #5178FF; padding: 2px 5px;'
                    : props.row.status == 'descartada'
                    ? 'width: fit-content; background:  #EBEEFE; padding: 2px 5px;'
                    : props.row.status == 'sucata'
                    ? 'width: fit-content; background:  #F3E8E0; padding: 2px 5px;'
                    : props.row.status == 'furto'
                    ? 'width: fit-content; background:  #AB1D22; padding: 2px 5px;'
                    : props.row.status == 'aguardando_reparo'
                    ? 'width: fit-content; background:  #EDBC5A'
                    : props.row.status == 'aguardando_calibracao'
                    ? 'width: fit-content; background:  #9BA4B5; padding: 2px 5px;'
                    : ''
                "
                class="row col-12 align items-center nao-quebrar-linha"
              >
                <span
                  v-if="props.row.status == 'disponivel'"
                  class="elipse q-mr-sm bg-positive"
                ></span>
                <span
                  v-if="props.row.status == 'uso'"
                  class="elipse q-mr-sm bg-warning"
                ></span>
                <span
                  v-if="props.row.status == 'manutencao_garantia'"
                  class="elipse q-mr-sm"
                  style="background: #424242"
                ></span>
                <span
                  v-if="props.row.status == 'manutencao'"
                  class="elipse q-mr-sm bg-red"
                ></span>
                <span
                  v-if="props.row.status == 'em_transito'"
                  class="elipse q-mr-sm"
                  style="background: #2d3e6e"
                ></span>
                <span
                  v-if="
                    props.row.status == 'removida' ||
                    props.row.status == 'calibracao'
                  "
                  class="elipse q-mr-sm"
                  style="background: #383737"
                ></span>
                <span
                  v-if="props.row.status == 'retorno_em_garantia'"
                  class="elipse q-mr-sm"
                  style="background: #383737"
                ></span>
                <span
                  v-if="props.row.status == 'desmobilizada'"
                  class="elipse q-mr-sm"
                  style="background: #fa9726"
                ></span>
                <span
                  v-if="props.row.status == 'reativacao'"
                  class="elipse q-mr-sm"
                  style="background: #473fe8"
                ></span>
                <span
                  v-if="props.row.status == 'descartada'"
                  class="elipse q-mr-sm"
                  style="background: #b0cde8"
                ></span>
                <span
                  v-if="props.row.status == 'sucata'"
                  class="elipse q-mr-sm"
                  style="background: #736d6a"
                ></span>
                <span
                  v-if="props.row.status == 'furto'"
                  class="elipse q-mr-sm"
                  style="background: #6b1215"
                ></span>
                <span
                  v-if="props.row.status == 'aguardando_reparo'"
                  class="elipse q-mr-sm"
                  style="background: #fa9726"
                ></span>
                <span
                  v-if="props.row.status == 'aguardando_calibracao'"
                  class="elipse q-mr-sm"
                  style="background: #11009e"
                ></span>
                <div
                  v-if="props.row.status == 'disponivel'"
                  style="width: fit-content; background: #e8ffec"
                  class="text-brand-5 text-bold"
                >
                  {{ "Disponível" }}
                </div>
                <div
                  v-if="props.row.status == 'uso'"
                  style="width: fit-content; background: #fefed1"
                  class="text-brand-5 text-bold"
                >
                  {{ "Em Uso" }}
                </div>
                <div
                  v-if="props.row.status == 'manutencao_garantia'"
                  style="width: fit-content"
                  class="text-brand-5 text-bold"
                >
                  {{ "Manutenção Garantia" }}
                </div>
                <div
                  v-if="props.row.status == 'manutencao'"
                  style="width: fit-content"
                  class="text-red text-bold"
                >
                  {{ "Manutenção" }}
                </div>
                <div
                  v-if="props.row.status == 'em_transito'"
                  style="width: fit-content; color: #192957"
                  class="text-bold nao-quebrar-linha"
                >
                  {{ "Em Trânsito" }}
                </div>
                <div
                  v-if="props.row.status == 'removida'"
                  style="width: fit-content"
                  class="text-bold"
                >
                  {{ "Removida" }}
                </div>
                <div
                  v-if="props.row.status == 'retorno_em_garantia'"
                  style="width: fit-content"
                  class="text-bold"
                >
                  {{ "Retorno Em Garantia" }}
                </div>
                <div
                  v-if="props.row.status == 'desmobilizada'"
                  style="width: fit-content"
                  class="text-bold"
                >
                  {{ "Desmobilizada" }}
                </div>
                <div
                  v-if="props.row.status == 'reativacao'"
                  style="width: fit-content"
                  class="text-bold"
                >
                  {{ "Reativação" }}
                </div>
                <div
                  v-if="props.row.status == 'descartada'"
                  style="width: fit-content"
                  class="text-bold"
                >
                  {{ "Descartada" }}
                </div>
                <div
                  v-if="props.row.status == 'sucata'"
                  style="width: fit-content"
                  class="text-bold"
                >
                  {{ "Sucata" }}
                </div>
                <div
                  v-if="props.row.status == 'furto'"
                  style="width: fit-content"
                  class="text-bold"
                >
                  {{ "Furto" }}
                </div>
                <div
                  v-if="props.row.status == 'aguardando_reparo'"
                  style="width: fit-content"
                  class="text-bold"
                >
                  {{ "Aguardando Reparo" }}
                </div>
                <div
                  v-if="props.row.status == 'calibracao'"
                  style="width: fit-content"
                  class="text-bold"
                >
                  {{ "Calibração" }}
                </div>
                <div
                  v-if="props.row.status == 'aguardando_calibracao'"
                  style="width: fit-content"
                  class="text-bold"
                >
                  {{ "Aguardando Calibração" }}
                </div>
              </div>
            </q-td>

            <q-td class="text-left" key="funcionario" :props="props">
              <div>{{ props.row.nome_funcionario }}</div>
            </q-td>

            <q-td class="text-left" key="dataRetirada" :props="props">
              {{
                props.row.retirada == null
                  ? ""
                  : props.row.retirada
                      .split(" ")[0]
                      .split("-")
                      .reverse()
                      .join("/")
              }}
              <p style="margin: 0 0 0 9px">
                {{
                  props.row.retirada == null
                    ? ""
                    : props.row.retirada.split(" ")[1]
                }}
              </p>
            </q-td>
            <q-td class="text-left" key="previsaoDevolucao" :props="props">
              {{
                props.row.previsao_entrega == null
                  ? ""
                  : props.row.previsao_entrega
                      .split(" ")[0]
                      .split("-")
                      .reverse()
                      .join("/")
              }}
              <p style="margin: 0 0 0 9px">
                {{
                  props.row.previsao_entrega == null
                    ? ""
                    : props.row.previsao_entrega.split(" ")[1]
                }}
              </p>
            </q-td>
            <q-td class="text-left" key="grupo" :props="props">{{
              props.row.categoria_nome
            }}</q-td>
            <q-td class="text-left" key="subGrupo" :props="props">{{
              props.row.grupo_nome
            }}</q-td>
          </q-tr>
        </template>
        <template v-slot:top-right>
          <q-btn
            class="q-mr-sm"
            color="secondary"
            icon="file_upload"
            label="Exportar Todas Unidades"
            type="submit"
            no-caps
            @click="exportar2"
          />
          <q-btn
            color="secondary"
            icon="file_upload"
            label="Exportar"
            type="submit"
            no-caps
            @click="exportar()"
          />
        </template>
      </q-table>
      <div class="row justify-start q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>
  </q-page>
</template>

<script>
import { onMounted, ref, watch, computed } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { watchDebounced } from "@vueuse/core";
import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import SelectComponentGrupos from "../components/SelectComponentGrupos.vue";
import SelectComponentSubGrupos from "../components/SelectComponentSubGrupos.vue";
import PageHeader from "../../../components/PageHeader.vue";

export default {
  components: {
    ListaUnidadesSelect,
    SelectComponentGrupos,
    SelectComponentSubGrupos,
    PageHeader,
  },
  name: "RelatórioMovimentacao",

  setup() {
    const store = useStore();
    const $q = useQuasar();
    let loading = ref(false);
    let semDados = ref(false);
    let hideBottom = ref(true);
    let recebeUnidade = ref({
      unidade: store.state.org.unidadeData.nome,
      id: store.state.org.unidadeData.id,
    });
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 6,
    });
    const filtros = ref({
      funcionario: "",
      status: "",
      codigo: "",
      descricao: "",
    });
    const grupo = ref({});
    const subGrupo = ref({});

    const status = ref([
      { label: "Todos", value: "" },
      { label: "Disponível", value: "disponivel" },
      { label: "Em Uso", value: "uso" },
      { label: "Manutenção", value: "manutencao" },
      { label: "Manutenção Garantia", value: "manutencao_garantia" },
      { label: "Removida", value: "removida" },
      { label: "Reativação", value: "reativacao" },
      { label: "Desmobilizada", value: "desmobilizada" },
      { label: "Retorno em Garantia", value: "retorno_em_garantia" },
      { label: "Descartada", value: "descartada" },
      { label: "Furto", value: "furto" },
      { label: "Sucata", value: "sucata" },
      { label: "Aguardando Reparo", value: "aguardando_reparo" },
      { label: "Calibração", value: "calibracao" },
      { label: "Aguardando Calibração", value: "aguardando_calibracao" },
    ]);

    const ferramentas = ref([]);
    let disable = ref(false);

    const columns = [
      {
        name: "unidade",
        label: "Unidade",
        field: "unidade",
        align: "left",
        sortable: true,
      },
      {
        name: "codigo",
        label: "Código",
        field: "nome",
        align: "left",
        sortable: false,
      },
      {
        name: "descricao",
        label: "Descrição",
        field: "descricao",
        align: "left",
        sortable: false,
      },
      {
        name: "preco",
        label: "Preço",
        field: "preco",
        align: "left",
        sortable: false,
      },
      {
        name: "patrimonio",
        label: "Patrimônio",
        field: "patrimonio",
        align: "left",
        sortable: false,
      },
      {
        name: "permanencia",
        label: "Permanência",
        field: "permanencia",
        align: "left",
        sortable: false,
      },
      {
        name: "status",
        label: "Status",
        field: "status",
        align: "left",
        sortable: false,
      },
      {
        name: "funcionario",
        label: "Colaborador",
        field: "funcionario",
        align: "left",
        sortable: false,
      },
      {
        name: "dataRetirada",
        label: "Data Retirada",
        align: "left",
        sortable: false,
      },
      {
        name: "previsaoDevolucao",
        label: "Data Devolução",
        align: "left",
      },
      {
        name: "grupo",
        label: "Grupo",
        field: "categoria_nome",
        align: "left",
      },
      {
        name: "subGrupo",
        label: "Subgrupo",
        field: "grupo_nome",
        align: "left",
      },
    ];
    const filter = ref("");
    let todasUnidades = ref(false);

    let filtrar = async (page = 0, rowsNumber = 6) => {
      loading.value = true;
      disable.value = true;
      hideBottom.value = true;
      if (filtros.value.status == "Todos") {
        filtros.value.status = "";
      }

      let resposta = await store.dispatch("fer/relatorioFerramentas", {
        unidadeId: recebeUnidade.value.id,
        funcionario: filtros.value.funcionario,
        status: filtros.value.status?.value,
        codigo: filtros.value.codigo,
        descricao: filtros.value.descricao,
        patrimonio: filtros.value.patrimonio,
        grupo: grupo.value?.nome,
        sub_grupo: subGrupo.value?.nome,
        per_page: rowsNumber,
        ferramenta: filter.value,
        page: page,
      });

      ferramentas.value = resposta.resposta.data.result.data;
      pagination.value.rowsPerPage = resposta.resposta.data.result.per_page;
      pagination.value.page = resposta.resposta.data.result.current_page;
      pagination.value.rowsNumber = resposta.resposta.data.result.total;
      loading.value = false;
      disable.value = false;

      if (ferramentas.value == "") {
        semDados.value = true;
        hideBottom.value = false;
      }
    };

    const receberDadosGrupo = async (value) => {
      grupo.value = value;
    };

    const receberDadosSubGrupo = async (value) => {
      subGrupo.value = value;
    };

    onMounted(filtrar);

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        recebeUnidade.value.unidade = JSON.parse(getunidade);
      }
    };

    onMounted(getUnidade);

    let exportar = async () => {
      await store.dispatch("fer/exportarRelatorioFerramentas", {
        unidadeId: recebeUnidade.value.id,
        funcionario: filtros.value.funcionario,
        status: filtros.value.status,
      });
      $q.notify({
        message:
          "Seu relatório de FERRAMENTAS está sendo processado, você receberá um link pra download no seu email assim que ele estiver pronto!",
        color: "positive",
        actions: [
          {
            label: "Fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
    };

    let exportar2 = async () => {
      await store.dispatch("fer/exportarRelatorioFerramentas", {
        unidadeId: "",
        funcionario: filtros.value.funcionario,
        status: filtros.value.status,
      });
      $q.notify({
        message:
          "Seu relatório de FERRAMENTAS está sendo processado, você receberá um link pra download no seu email assim que ele estiver pronto!",
        color: "positive",
        actions: [
          {
            label: "Fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        if (store.state.org.unidadeData == null) {
          recebeUnidade.value.unidade = "";
          recebeUnidade.value.id = "";
          filtrar();
          return;
        }
        recebeUnidade.value.unidade = store.state.org.unidadeData;
        recebeUnidade.value.id = store.state.org.unidadeData.id;
        filtrar();
      }
    );

    watch(
      () => pagination.value.page,
      () => {
        filtrar(pagination.value.page, pagination.value.rowsPerPage);
      }
    );

    watchDebounced(
      [
        () => filtros.value.status,
        () => filtros.value.funcionario,
        () => filtros.value.codigo,
        () => filtros.value.descricao,
        () => filtros.value.patrimonio,
        () => grupo.value,
        () => subGrupo.value,
      ],
      () => {
        filtrar();
      },
      { debounce: 400 }
    );

    return {
      filtros,
      filter,
      columns,
      ferramentas,
      recebeUnidade,
      filtrar,
      status,
      exportar,
      loading,
      semDados,
      hideBottom,
      receberDadosGrupo,
      grupo,
      subGrupo,
      receberDadosSubGrupo,
      pagination,
      disable,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      exportar2,
      todasUnidades,
    };
  },
};
</script>

<style scoped>
.elipse {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
.nao-quebrar-linha {
  display: flex;
  flex-wrap: nowrap !important;
}
tbody tr td {
  white-space: pre-wrap;
}
</style>
